import {Alias} from '@models/adminstration/gateway/gateway-configuration/alias';
import {GatewayValues} from '@models/adminstration/gateway/gateway-configuration/gateway-values';
import {GatewayArray} from '@models/adminstration/gateway/gateway-configuration/gateway-array';
import {AdcSetting} from '@models/adminstration/gateway/gateway-configuration/adc-setting';
import {Device} from '@models/adminstration/gateway/gateway-configuration/device';
import {ModbusSetting} from '@models/adminstration/gateway/gateway-configuration/modbus-setting';

export class GatewaySignals {
  adc: AdcSetting = new AdcSetting();
  adcIds: any;
  alias: Alias = new Alias('', []);
  arrayIds: any;
  arrays: GatewayArray[] = [];
  device: Device | null = new Device();
  fwDownload: any;
  id: number = -1;
  iotCore: any;
  modbus: ModbusSetting = new ModbusSetting();
  modbusIds: any;
  parent: any;
  parentId: string = '';
  streamToBigTable: boolean = false;
  dataImputation: boolean = false;
  eavViewEnabled: boolean = false;
  streamEventDataToPubSub: boolean = false;
  typeOfData: string = '';
  valueIds: number[] = [];
  values: GatewayValues[] = [];
}